import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { td, th } from './ui';

type CompareKey =
  | 'title'
  | 'who'
  | 'several'
  | 'final'
  | 'return'
  | 'whoOffice'
  | 'whoLead'
  | 'whoLeadOffice'
  | 'whoSelf'
  | 'severalNone'
  | 'severalOne'
  | 'severalOneNoThird'
  | 'finalOffice'
  | 'finalLead'
  | 'finalLeadOffice'
  | 'finalSelf'
  | 'returnOffice'
  | 'returnLead'
  | 'returnLeadOffice'
  | 'returnSelf'
  | 'note';

/**
 * The approval modes side by side (round 5, request 8): who approves, what several project leads mean (one is enough,
 * never a third stage), when hours count as approved and billable, and who may return approved hours.
 */
export function ApprovalCompare({ className }: { className?: string }) {
  const { t } = useTranslation();
  const c = (k: CompareKey) => t(`projects.approval.compare.${k}`);
  const cols = ['office', 'lead', 'lead_office', 'self'] as const;
  const rows: { label: string; cells: string[] }[] = [
    { label: c('who'), cells: [c('whoOffice'), c('whoLead'), c('whoLeadOffice'), c('whoSelf')] },
    { label: c('several'), cells: [c('severalNone'), c('severalOne'), c('severalOneNoThird'), c('severalNone')] },
    { label: c('final'), cells: [c('finalOffice'), c('finalLead'), c('finalLeadOffice'), c('finalSelf')] },
    { label: c('return'), cells: [c('returnOffice'), c('returnLead'), c('returnLeadOffice'), c('returnSelf')] },
  ];
  return (
    <details className={clsx('text-sm', className)}>
      <summary className="cursor-pointer text-accent select-none">{c('title')}</summary>
      <div className="scroll-x mt-2">
        <table className="w-full min-w-[40rem] text-xs">
          <thead className="border-b border-line">
            <tr>
              <th className={th} />
              {cols.map((m) => (
                <th key={m} className={th}>
                  {t(`projects.approval.modes.${m}`)}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.label} className="border-b border-line/60 align-top">
                <th scope="row" className={clsx(td, 'font-medium')}>
                  {r.label}
                </th>
                {r.cells.map((x, i) => (
                  <td key={i} className={td}>
                    {x}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="mt-2 text-xs text-graphite">{c('note')}</p>
    </details>
  );
}
